import React from "react";
import { useNavigate } from "react-router-dom";
import {
  FaFacebookF,
  // FaTwitter,
  FaInstagram,
  // FaLinkedinIn,
  FaArrowUp,
} from "react-icons/fa";
import { MdEmail, MdLocationOn } from "react-icons/md";
import "../styles/Footer.css"; // You can also use Tailwind or styled-components if preferred
import logo from "../Utils/Logos/logo.png";
import { useState } from "react";
import { useAuth } from "../Auth/AuthContext";
import OrganizerOnboardModal from "../Auth/OrganizerOnboardModal";
const Footer = () => {
  const navigate = useNavigate();
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showOnboardModal, setShowOnboardModal] = useState(false);
  const { user } = useAuth();

  const handleNavigate = (path) => {
    navigate(path);
  };

  return (
    <footer className="footer">
      <div className="footer-top">
        {/* Left Column */}
        <div className="footer-brand">
          <div className="footer-logo">
            <img src={logo} className="logo-icon" alt="logo"/>
            <h2 className="gradient-text">Tixoza</h2>
          </div>
          <p>
            Discover amazing events, connect with your community, and create
            unforgettable experiences with Tixoza - your trusted event
            ticketing platform.
          </p>
          <div className="contact-info">
            <p>
              <MdEmail size={24} className="footer-icons" /> support@tixoza.com
            </p>
            <p>
              <MdLocationOn size={24} className="footer-icons" /> Ahmedabad, India
            </p>
          </div>
        </div>

        {/* Columns */}
        <div className="footer-columns">
          <div>
            <h4>Company</h4>
            <ul>
              <li onClick={() => handleNavigate("/about-us")}>About Us</li>
              {/* <li onClick={() => handleNavigate("/contact-support")}>
                Contact Support
              </li> */}
            </ul>
          </div>
          <div>
            <h4>Support</h4>
            <ul>
              <li onClick={() => handleNavigate("/faq")}>FAQ</li>
              
              <li onClick={() => handleNavigate("/contact-support")}>
                Contact Support
              </li>
             
            </ul>
          </div>
          <div>
            <h4>Legal</h4>
            <ul>
              {/* <li>Terms of Service</li> */}
              <li onClick={() => handleNavigate("/terms-of-service")}>
                Terms Of Services
              </li>
              <li onClick={() => handleNavigate("/privacy-policy")}>Privacy Policy</li>
              <li onClick={() => handleNavigate("/cookie-policy")}>Cookie Policy</li>
              <li onClick={() => handleNavigate("/refund-policy")}>Refund Policy</li>
              <li onClick={() => handleNavigate("/qr-code-security-policy")}>QR Code Policy</li>
            </ul>
          </div>
          <div>
            <h4>For Organizers</h4>
            <ul>
              <li onClick={() => handleNavigate("/terms-and-conditions-for-organizers")}>
                T&C For Organizers
              </li>
              <li onClick={() => handleNavigate("/for-organizers")}>
                For Organizers
              </li>
              {/* <li
                onClick={() =>
                  // handleNavigate("/dashboard?showCreateModal=true")
                  handleNavigate("/for-organizers")
                }
              >
                Host Events
              </li> */}
              <li onClick={() => handleNavigate("/pricing")}>Pricing</li>
            </ul>
          </div>
        </div>

        {/* App Button */}
      </div>

      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} Tixoza. All rights reserved.</p>
        <div className="social-icons">
          <FaFacebookF className="si" />
          {/* <FaTwitter className="si" /> */}
          <FaInstagram className="si" />
          {/* <FaLinkedinIn className="si" /> */}
        </div>
        <div className="download-app">
        { user?.role === 'user' ? (
          <button onClick={() => setShowConfirmModal(true)}>Switch to Organizer</button>
        ) : (<></>)
        }
        </div>
      </div>

      {/* <div className="footer-description">
        <div>
          <h4 className="purple">For Event Attendees</h4>
          <p>
            Discover, book, and enjoy amazing events with secure payments and
            instant tickets.
          </p>
        </div>
        <div>
          <h4 className="blue">For Event Organizers</h4>
          <p>
            Create, promote, and manage your events with powerful tools and
            analytics.
          </p>
        </div>
        <div>
          <h4 className="gradient-text">Secure & Reliable</h4>
          <p>
            Your data and payments are protected with enterprise-grade security.
          </p>
        </div>
      </div> */}

      {/* Scroll to Top Button */}
      <button
        className="scroll-to-top"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      >
        <FaArrowUp />
      </button>

      {/* Confirmation Modal */}
      {showConfirmModal && (
        <div className="confirmation-modal-overlay">
          <div className="confirmation-modal">
            <h3>Confirm Switch to Organizer</h3>
            <p>Are you sure you want to switch your account to organizer?</p>
            <div className="confirmation-modal-buttons">
              <button
                className="cancel-button"
                onClick={() => setShowConfirmModal(false)}
              >
                Cancel
              </button>
              <button
                className="confirm-button"
                onClick={() => {
                  setShowConfirmModal(false);
                  setShowOnboardModal(true);
                }}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Organizer Onboard Modal */}
      <OrganizerOnboardModal
        show={showOnboardModal}
        handleClose={() => setShowOnboardModal(false)}
        onOnboarded={() => {
          setShowOnboardModal(false);
          navigate("/my-profile");
        }}
      />
    </footer>
  );
};

export default Footer;
